import { Container, Box, Stack, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import ActionButton from "../../account/ActionButton";

import SettlementConfirmationInfoCard from "./SettlementConfirmationInfoCard";

import { useArrangement } from "../../../context/ArrangementProvider";
import { useSettlement } from "../../../context/SettlementProvider";

import ScrollToTop from "../../nav/ScrollToTop";

/** 
 * The settlement plan confirmation page
 * */
function SettlementConfirmation({ activeStep, steps }) {

  const {
    lastSavedPlan,
    setLastSavedPlan,
  } = useArrangement();

  const {
    selectedOption,
    settlementPlan,
    updateSettlementPlan,
  } = useSettlement();

  const navigate = useNavigate();
  const handleClick = () => {
    updateSettlementPlan({ ...settlementPlan, isSettlement: true });
    setLastSavedPlan({ ...lastSavedPlan, isSettlement: true });
    navigate(selectedOption === "1" ? "/payment" : "/");
  };

  return (
    <>
      <ScrollToTop />
      <Typography
        variant="h5"
        component="label"
        htmlFor="email"
        fontWeight={"bold"}
      >
        Settlement Plan
      </Typography>
      <Stack
        sx={{
          mt: 2,
          mb: 5,
        }}
        spacing={2}
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        <Box
          id='payment-plan-container'
          sx={{ width: "100%", textAlign: "center", pt: 2, pb: 4 }}
        >
          <CheckCircle color='success' sx={{ fontSize: 72, mb: 2 }} />

          <Typography fontWeight={"bold"}>Repayment plan confirmed</Typography>

          <Typography sx={{ py: 1, px: 1 }}>
            Thank you for setting up a settlement repayment plan.
          </Typography>

          <Typography sx={{ py: 1, px: 1 }}>
            We can confirm that your account is now on a settlement plan.
          </Typography>

          <Typography sx={{ py: 1, px: 1 }}>
            Once we've received the agreed settlement payment - we'll update any entry on your credit file to reflect this account has been 'partially satisfied',
            and the outstanding balance will show as £0.
            <br />
            <br />
            We therefore won't ever ask you to pay the remainder of the balance.
            <br />
            <br />
            We recommend checking your credit file 8-12 weeks after the account has been closed to see this update.
          </Typography>

          <Container sx={{ py: 2 }}>
            {
              /* Stepper process complete so render home link */
              activeStep === steps.length - 1 && (
                <ActionButton
                  id={selectedOption === "1" ? "make-payment-btn" : "return-home-btn"}
                  variant='contained'
                  buttonColor='secondary.main'
                  buttonTextColor='primary.contrastText'
                  borderColor='transparent'
                  hoverColor='primary.contrastText'
                  hoverBorderColor='secondary.main'
                  hoverTextColor='secondary.main'
                  buttonTitle={selectedOption === "1" ? "Make a payment" : "Return home"}
                  onClick={handleClick}
                />
              )
            }
          </Container>
        </Box>

        <Box sx={{ width: "100%" }}>
          <SettlementConfirmationInfoCard />
        </Box>
      </Stack>
    </>
  );
}

export default SettlementConfirmation;
